import { Dialog } from "@excalidraw/excalidraw/components/Dialog";
import { FilledButton } from "@excalidraw/excalidraw/components/FilledButton";
import { TextField } from "@excalidraw/excalidraw/components/TextField";
import { useState } from "react";

import { useAtom } from "../../app-jotai";
import { saveAsNewCloudDoc } from "../cloudActions";
import { getCurrentCloudDoc } from "../currentDoc";
import { saveToCloudDialogAtom } from "../dialogState";

import { FolderPicker } from "./FolderPicker";

export const SaveToCloudDialog = () => {
  const [state, setState] = useAtom(saveToCloudDialogAtom);
  const [name, setName] = useState("");
  const [folder, setFolder] = useState(
    () => getCurrentCloudDoc()?.folderPath ?? "",
  );
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!state.isOpen) {
    return null;
  }

  const close = () => {
    setState({ isOpen: false });
    setName("");
    setError(null);
  };

  const submit = async () => {
    if (!name.trim()) {
      setError("Please enter a name");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await saveAsNewCloudDoc(
        name.trim(),
        folder.trim().replace(/^\/+|\/+$/g, ""),
      );
      close();
    } catch (e: any) {
      setError(e?.message || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      size="small"
      onCloseRequest={close}
      title={state.mode === "saveAs" ? "Save a copy to cloud" : "Save to cloud"}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <TextField
          label="Name"
          placeholder="My drawing"
          value={name}
          onChange={setName}
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />
        <div style={{ fontSize: "0.85rem", fontWeight: 600 }}>Folder</div>
        <FolderPicker path={folder} onPathChange={setFolder} />
        {error && (
          <div style={{ color: "var(--color-danger)", fontSize: "0.85rem" }}>
            {error}
          </div>
        )}
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}
        >
          <FilledButton
            variant="outlined"
            color="muted"
            label="Cancel"
            onClick={close}
          />
          <FilledButton label={busy ? "Saving…" : "Save"} onClick={submit} />
        </div>
      </div>
    </Dialog>
  );
};
